import React, { useState } from 'react';
import { CONFIG } from '../config';

const HeyDJRequestPage = ({ eventCode }) => {
  const [guestName, setGuestName] = useState('');
  const [songRequest, setSongRequest] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!songRequest.trim()) return;

    setSubmitting(true);
    setError(null);

    try {
      const resp = await fetch(`${CONFIG.apiBaseUrl}/public/dj-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event_code: eventCode,
          guest_name: guestName.trim() || undefined,
          message_body: songRequest.trim(),
        }),
      });

      if (!resp.ok) {
        const data = await resp.json();
        throw new Error(data.error || 'Failed to submit request');
      }

      setSubmitted(true);
      setSongRequest('');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleSubmitAnother = () => {
    setSubmitted(false);
    setError(null);
  };

  return (
    <div className="addme-page">
      <div className="addme-container">
        <h2>#HeyDJ</h2>
        <p style={{ textAlign: 'center', color: '#555', marginBottom: '20px' }}>
          Submit a song request
        </p>

        {submitted ? (
          <div style={{ textAlign: 'center' }}>
            <div className="success-message" style={{ marginBottom: '20px' }}>
              Song request submitted!
            </div>
            <button onClick={handleSubmitAnother} className="btn btn-primary">
              Submit Another Request
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div className="error-message">{error}</div>}

            <div className="form-group">
              <label htmlFor="guestName" className="form-label">Your Name (optional)</label>
              <input
                type="text"
                id="guestName"
                value={guestName}
                onChange={(e) => setGuestName(e.target.value)}
                placeholder="Enter your name"
                className="form-input"
                maxLength={100}
              />
            </div>

            <div className="form-group">
              <label htmlFor="songRequest" className="form-label">Song Request</label>
              <textarea
                id="songRequest"
                value={songRequest}
                onChange={(e) => setSongRequest(e.target.value)}
                placeholder="Enter song title and artist"
                className="form-input"
                rows={3}
                maxLength={500}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitting || !songRequest.trim()}
              style={{ width: '100%' }}
            >
              {submitting ? 'Submitting...' : 'Submit Request'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default HeyDJRequestPage;
